import { render, staticRenderFns } from "./TabModalGroup.vue?vue&type=template&id=d28c5c92&scoped=true&"
import script from "./TabModalGroup.vue?vue&type=script&lang=js&"
export * from "./TabModalGroup.vue?vue&type=script&lang=js&"
import style0 from "./TabModalGroup.vue?vue&type=style&index=0&id=d28c5c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28c5c92",
  null
  
)

export default component.exports